import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Input, Options } from './components';
import { useInitialValue, useKeyboard, useShowOptions, useStore } from './hooks';
import { useClassName } from '../../hooks';
import './AutoComplete.scss';
import { useOptionsCache } from './hooks/useOptionsCache';
/**
 * AutoComplete component used to display the options in a dropdown and filter them based on the input value.
 * It handles paginated loading for the options.
 *
 *
 * update select logic
 * update value display logic
 * update on click logic
 *
 */
export const AutoComplete = ({ placeholder, onSearch, options, fetching, loading, onDelete, onScrollEnd, onSelect, removable, selectedValues, inputTestId, mode = 'multiple', mask = (value) => value, disabled, onClear, }) => {
    const { focused, optionsAreOpen, setFocused, setOptionsAreOpen, setValue, value, setCurrentIndex, currentIndex } = useStore();
    const ref = useRef(null);
    const inputRef = useRef(null);
    const className = useClassName({ name: 'auto-complete', prefixed: true });
    const optionsCache = useOptionsCache({ options });
    useInitialValue({ optionsCache, setValue, selectedValues, mode });
    useShowOptions({ focused, setOptionsAreOpen, options });
    useKeyboard({
        mode,
        selectedValues,
        optionsAreOpen,
        focused,
        setFocused,
        options,
        setCurrentIndex,
        currentIndex,
        onSelect,
        setOptionsAreOpen,
        ref,
    });
    return (_jsxs("div", { ref: ref, className: className, children: [_jsx(Input, { onClear: onClear, disabled: disabled, inputRef: inputRef, mask: mask, setFocused: setFocused, setValue: setValue, value: value, placeholder: placeholder, onSearch: onSearch, fetching: fetching, loading: loading, inputTestId: inputTestId }), _jsx(Options, { inputRef: inputRef, optionsCache: optionsCache, setFocused: setFocused, setOptionsAreOpen: setOptionsAreOpen, mode: mode, setCurrentIndex: setCurrentIndex, currentIndex: currentIndex, setValue: setValue, value: value, optionsAreOpen: optionsAreOpen, onSelect: onSelect, removable: removable, onDelete: onDelete, options: options, loading: loading, onSearch: onSearch, onScrollEnd: onScrollEnd, fetching: fetching, selectedValues: selectedValues })] }));
};
